import "./ContactSideBar.scss";
import Category from "../../Sidebar/Category/Category";
interface SideBarProps {
  openFile: (value: any) => void;
}
const ContactSideBar: React.FC<SideBarProps> = ({ openFile }) => {
  const channels = [
    {
      id: "youtube",
      link: "https://www.youtube.com/channel/UCMyiGJVoGslugXMuR1CxiXg",
      icon: (
        <svg
          width="20"
          height="16"
          viewBox="0 0 20 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.543 2.498C20 4.28 20 8 20 8C20 8 20 11.72 19.543 13.502C19.289 14.487 18.546 15.262 17.605 15.524C15.896 16 10 16 10 16C10 16 4.107 16 2.395 15.524C1.45 15.258 0.708 14.484 0.457 13.502C2.98023e-08 11.72 0 8 0 8C0 8 2.98023e-08 4.28 0.457 2.498C0.711 1.513 1.454 0.738 2.395 0.476C4.107 -1.78814e-07 10 0 10 0C10 0 15.896 -1.78814e-07 17.605 0.476C18.55 0.742 19.292 1.516 19.543 2.498ZM8 11.5L14 8L8 4.5V11.5Z"
            fill="#607B96"
          />
        </svg>
      ),
      label: "YouTube channel",
    },
    {
      id: "discord-account",
      link: "https://discord.com/users/hamzarihani#9666",
      icon: (
        <svg
          width="18"
          height="21"
          viewBox="0 0 18 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.076 9C7.676 9 8.162 9.45 8.151 10C8.151 10.55 7.677 11 7.076 11C6.486 11 6 10.55 6 10C6 9.45 6.475 9 7.076 9ZM10.924 9C11.525 9 12 9.45 12 10C12 10.55 11.525 11 10.924 11C10.334 11 9.849 10.55 9.849 10C9.849 9.45 10.323 9 10.924 9ZM15.891 0C17.054 0 18 0.966 18 2.163V21L15.789 19.005L14.544 17.829L13.227 16.579L13.773 18.522H2.109C0.946 18.522 0 17.556 0 16.359V2.163C0 0.966 0.946 0 2.109 0H15.89H15.891ZM11.921 13.713C14.194 13.64 15.069 12.117 15.069 12.117C15.069 8.736 13.587 5.995 13.587 5.995C12.107 4.862 10.697 4.893 10.697 4.893L10.553 5.061C12.302 5.607 13.114 6.395 13.114 6.395C12.1591 5.85699 11.1066 5.51434 10.018 5.387C9.32744 5.309 8.62993 5.31572 7.941 5.407C7.879 5.407 7.827 5.418 7.766 5.428C7.406 5.46 6.531 5.596 5.431 6.09C5.051 6.268 4.824 6.395 4.824 6.395C4.824 6.395 5.678 5.565 7.529 5.019L7.426 4.893C7.426 4.893 6.017 4.862 4.536 5.996C4.536 5.996 3.055 8.736 3.055 12.117C3.055 12.117 3.919 13.639 6.192 13.713C6.192 13.713 6.572 13.241 6.882 12.842C5.575 12.442 5.082 11.602 5.082 11.602C5.082 11.602 5.184 11.676 5.369 11.781C5.379 11.791 5.389 11.802 5.41 11.812C5.441 11.834 5.472 11.844 5.503 11.865C5.76 12.012 6.017 12.127 6.253 12.222C6.675 12.39 7.179 12.558 7.766 12.674C8.64532 12.8464 9.54941 12.8498 10.43 12.684C10.9429 12.5925 11.4433 12.4411 11.921 12.233C12.281 12.096 12.682 11.896 13.104 11.613C13.104 11.613 12.59 12.474 11.242 12.863C11.551 13.262 11.922 13.713 11.922 13.713H11.921Z"
            fill="#607B96"
          />
        </svg>
      ),
      label: "Discord account",
    },
    {
      id: "discord-server",
      link: "https://discord.gg/WpvDpA5ZRQ",
      icon: (
        <svg
          width="18"
          height="21"
          viewBox="0 0 18 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.914 12.58C10.7537 12.6191 10.5923 12.6538 10.43 12.684C9.54941 12.8498 8.64532 12.8464 7.766 12.674C7.612 12.644 7.394 12.591 7.113 12.516L6.192 13.713C3.919 13.64 3.055 12.117 3.055 12.117C3.055 8.736 4.536 5.995 4.536 5.995C6.017 4.862 7.426 4.893 7.426 4.893L7.829 5.418C7.86614 5.41279 7.90352 5.40946 7.941 5.408C8.7092 5.30617 9.4877 5.30954 10.255 5.418L10.697 4.893C10.697 4.893 12.107 4.862 13.587 5.996C13.587 5.996 15.069 8.736 15.069 12.117C15.069 12.117 14.194 13.639 11.921 13.713L10.914 12.579V12.58ZM7.076 9C6.475 9 6 9.45 6 10C6 10.55 6.485 11 7.076 11C7.676 11 8.151 10.55 8.151 10C8.161 9.45 7.677 9 7.076 9ZM10.924 9C10.324 9 9.849 9.45 9.849 10C9.849 10.55 10.334 11 10.924 11C11.525 11 12 10.55 12 10C12 9.45 11.525 9 10.924 9ZM18 21L13.01 16H16V2H2V16H13.003L13.573 18H2C1.46957 18 0.960859 17.7893 0.585786 17.4142C0.210714 17.0391 0 16.5304 0 16V2C0 1.46957 0.210714 0.960859 0.585786 0.585786C0.960859 0.210714 1.46957 0 2 0H16C16.5304 0 17.0391 0.210714 17.4142 0.585786C17.7893 0.960859 18 1.46957 18 2V21Z"
            fill="#607B96"
          />
        </svg>
      ),
      label: "Discord server",
    },
  ];

  return (
    <div className="ContactSideBar-layout">
      <Category
        isInitializedAsOpen={true}
        title={"contacts"}
        type={"text"}
        textList={[
          {
            id: "email",
            icon: (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3 3H21C21.2652 3 21.5196 3.10536 21.7071 3.29289C21.8946 3.48043 22 3.73478 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3ZM12.06 11.683L5.648 6.238L4.353 7.762L12.073 14.317L19.654 7.757L18.346 6.244L12.061 11.683H12.06Z"
                  fill="#607B96"
                />
              </svg>
            ),
            label: "h.rihani@outlook.com",
          },
          {
            id: "phone",
            icon: (
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21 16.42V19.956C21.0001 20.2092 20.9042 20.453 20.7316 20.6382C20.559 20.8234 20.3226 20.9363 20.07 20.954C19.633 20.984 19.276 21 19 21C10.163 21 3 13.837 3 5C3 4.724 3.015 4.367 3.046 3.93C3.06372 3.67744 3.17658 3.44101 3.3618 3.26841C3.54703 3.09581 3.79082 2.99989 4.044 3H7.58C7.70404 2.99987 7.8237 3.04586 7.91573 3.12902C8.00776 3.21218 8.0656 3.32658 8.078 3.45C8.101 3.68 8.122 3.863 8.142 4.002C8.34073 5.38892 8.748 6.73783 9.35 8.003C9.445 8.203 9.383 8.442 9.203 8.57L7.045 10.112C8.36445 13.1865 10.8145 15.6365 13.889 16.956L15.429 14.802C15.4919 14.714 15.5838 14.6509 15.6885 14.6237C15.7932 14.5964 15.9042 14.6068 16.002 14.653C17.267 15.2539 18.6156 15.6601 20.002 15.858C20.141 15.878 20.324 15.9 20.552 15.922C20.6752 15.9346 20.7894 15.9926 20.8724 16.0846C20.9553 16.1766 21.0012 16.2961 21.001 16.42H21Z"
                  fill="#607B96"
                />
              </svg>
            ),
            label: "+216 20 979 006",
          },
        ]}
        openFile={(file: any) => openFile(file)}
        hidden={false}
      />
      <Category
        isInitializedAsOpen={true}
        title={"find-me-also-in"}
        type={"text"}
        textList={channels}
        openFile={(file: any) => openFile(file)}
        hidden={false}
      />
    </div>
  );
};
export default ContactSideBar;
